import { Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { LoginPage } from "./pages/LoginPage";
import { AppShell } from "./shell/AppShell";
import { OverviewPage } from "./pages/OverviewPage";
import { TenantsPage } from "./pages/TenantsPage";
import { CreateTenantPage } from "./pages/CreateTenantPage";
import { EditTenantPage } from "./pages/EditTenantPage";
import { KbPage } from "./pages/KbPage";

function Router() {
  const { status } = useAuth();
  if (status === "checking") return null;

  if (status === "anonymous") {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/tenants/:id/edit" element={<EditTenantPage />} />
        <Route path="/create" element={<CreateTenantPage />} />
        <Route path="/kb" element={<KbPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div id="app">
        <Router />
      </div>
      <Toaster theme="dark" richColors position="bottom-right" />
    </AuthProvider>
  );
}
